"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Range2dSharedObject = void 0;
const rc_js_util_1 = require("rc-js-util");
class Range2dSharedObject {
    constructor(wrapper, size) {
        this.byteSize = size;
        this.rvp = rc_js_util_1.RawVoidPointer.createOne(wrapper, size, true);
        this.sharedObject = this.rvp.sharedObject;
    }
    static createOneF32(wrapper) {
        return new Range2dSharedObject(wrapper, Float32Array.BYTES_PER_ELEMENT * 4);
    }
    static createOneF64(wrapper) {
        return new Range2dSharedObject(wrapper, Float64Array.BYTES_PER_ELEMENT * 4);
    }
    update(range) {
        range.copyToBuffer(this.rvp.getDataView(), 0, Range2dSharedObject.littleEndian);
    }
}
exports.Range2dSharedObject = Range2dSharedObject;
Range2dSharedObject.littleEndian = rc_js_util_1.isLittleEndian;
//# sourceMappingURL=range2d-shared-object.js.map